(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      // HOMEPAGE SCOPE. `eg-header--overlay` is rendered only on
      // request.page_type == 'index' (see the opening tag), so this one flag
      // is the whole homepage-only condition — no page sniffing, no hero
      // lookup that could be null on a template that has no hero.
      this.isOverlayHome = this.classList.contains('eg-header--overlay');
      this.pinnedQuery = window.matchMedia('(min-width: 990px)');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      // Drops the memoised homeGeometry() only. It does NOT read layout, so it
      // adds no work to a resize and does not touch --header-height, which
      // stays on its own matchMedia listener above.
      this.dropHomeGeometry = () => (this.geometry = undefined);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.dropHomeGeometry);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.dropHomeGeometry);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // PINNED ON DESKTOP INNER PAGES (Kyle, 2026-10-23). Off the homepage at
      // 990px and up the bar never hides or reveals; component-eg-chrome.css
      // pins it. Returning here keeps the hide/reveal classes off it entirely,
      // so the CSS pin has nothing to fight. Mobile and the homepage fall
      // through to the chain below unchanged.
      if (!this.isOverlayHome && this.pinnedQuery.matches) {
        this.header.classList.remove('shopify-section-header-hidden');
        this.currentScrollTop = scrollTop;
        return;
      }

      // Evergreen tuning, three departures from stock Dawn (1-2 Kyle,
      // 2026-07-23; 3 Kyle, 2026-08-04):
      // 1. INTENT: reveal only after 160px of accumulated upward travel; any
      //    downward movement resets the accumulator. The threshold is large
      //    on purpose: a Mac trackpad's lightest flick delivers 40-150px of
      //    momentum in a couple of scroll events, and the web cannot tell
      //    momentum from a finger — distance is the only intent signal
      //    there is. 160px dies out for a graze, survives a deliberate
      //    scroll-up. (Was 32px, which a mere touch blew straight through —
      //    Kyle bug, 2026-07-24.)
      // 2. NEAR-TOP GRACE: within 100px of where the in-flow header sits,
      //    don't slide the floating bar in at all — the real one is right
      //    there; let the scroll arrive at it. An already-revealed bar is
      //    left alone on the way up (yanking it mid-approach would jar);
      //    the reset at the very top handles the seam.
      // 3. HOMEPAGE HERO GATE (Kyle, 2026-08-04). Kyle's requirement is
      //    absolute: the painted bar is never on screen at the same time as a
      //    pixel of the hero photograph. That is an INVARIANT, not a trigger,
      //    so it is enforced two ways below the floor homeRevealFloor()
      //    measures — reveal is SUPPRESSED inside it, and a bar revealed above
      //    it is DISMISSED on the way back down through it (dismissBeforeHero).
      //    The dismissal is not the flicker Kyle rejected: it lands at the
      //    floor, PANEL_LIP px before the hero's first pixel, on a Vanilla
      //    panel that is the same colour as the painted bar. The flicker was
      //    firing over the photograph and undoing it over the photograph.
      //    Amended 2026-08-13: the dismissal is now a crossfade in place rather
      //    than a slide off the top — see dismissBeforeHero. The invariant and
      //    the floor it is measured against are unchanged.
      // 4. PINNED OVER THE HERO (Kyle, 2026-08-04): "the nav bar in the hero on
      //    the home page is never supposed to scroll." While ANY of the hero is
      //    on screen the bar holds station at the top of the window in its
      //    transparent white-coat state — it does not travel up with the page
      //    (the header is otherwise `position: relative`, so it did: measured
      //    top -899 at scrollY 899) and it does not slide away either. 3 already
      //    guarantees "never painted here"; this adds "never moves here". Past
      //    the boundary nothing changes — the chain below runs as it always has.
      const REVEAL_TRAVEL = 160;
      const NEAR_TOP_GRACE = 100;
      const pastHeader = scrollTop > this.headerBounds.bottom;
      const nearTop = scrollTop <= this.headerBounds.bottom + NEAR_TOP_GRACE;
      const belowHomeFloor = this.isOverlayHome && scrollTop <= this.homeRevealFloor();

      // The hero zone owns the bar outright, so this returns rather than
      // falling through: no hide, no reveal, no dismiss, no reset can reach it.
      // `scrollTop > 0` leaves the very top to reset(), whose classless state
      // renders identically (in-flow top 0 === pinned top 0) and is the state
      // the arrival animation is authored against.
      if (this.isOverlayHome && scrollTop > 0 && scrollTop < this.homeGeometry().heroAppearsAt) {
        requestAnimationFrame(this.pinOverHero.bind(this));
        this.upTravel = 0;
        this.currentScrollTop = scrollTop;
        return;
      }

      // Ahead of the branch chain, because the chain is gated on `pastHeader`
      // and the last 101px of the dismissal happen inside that gate. Positional
      // and idempotent — it reads scroll position and the current class, and
      // latches nothing, so oscillating across the floor cannot thrash or
      // strand a half-state, and crossing back above the floor re-arms the
      // ordinary reveal with no "already dismissed" memory to clear.
      if (belowHomeFloor && this.header.classList.contains('eg-bar-painted')) {
        requestAnimationFrame(this.dismissBeforeHero.bind(this));
      }

      if (scrollTop > this.currentScrollTop && pastHeader) {
        this.upTravel = 0;
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && pastHeader) {
        this.upTravel = (this.upTravel || 0) + (this.currentScrollTop - scrollTop);
        if (!this.preventReveal) {
          if (this.upTravel > REVEAL_TRAVEL && !nearTop && !belowHomeFloor) {
            requestAnimationFrame(this.reveal.bind(this));
          }
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.upTravel = 0;
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    // `eg-bar-painted` is the ONE theme-owned state class: set on reveal,
    // cleared by dismissBeforeHero and on the return to top, deliberately left
    // alone by hide() so a bar sliding out after a reveal stays painted. All
    // Evergreen paint CSS keys on it; the shopify-* classes stay purely
    // positional (Dawn's).
    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate', 'eg-bar-painted');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    // Hold the bar at the top of the window, transparent, for as long as any
    // hero pixel is on screen. It is `reveal()` without the paint: the same
    // `shopify-section-header-sticky` Dawn already uses for every other pinned
    // state, so this is not a new positioning scheme — the header is `relative`
    // only at the very top of the page, and sticky everywhere else regardless.
    //
    // NOTHING LAYS OUT DIFFERENTLY. Sticky keeps the element's box in normal
    // flow, so `.section-header:has(.eg-header--overlay)`'s negative bottom
    // margin in component-eg-chrome.css still pulls the hero up under the bar
    // by exactly --header-height; only the paint position moves. Checked, not
    // assumed: hero rect top stays 0 and --header-height stays 101px.
    //
    // `animate` is added here for the state the bar is handed off INTO, not for
    // this one. It no longer moves anything while the bar is light:
    // component-eg-chrome.css locks the light coat to `top: 0` and gives it a
    // transition list with no `top` in it, so the seam crossings this used to
    // smooth (0 -> -103 leaving the zone, -103 -> 0 returning) cannot happen to
    // the light bar at all — it does not travel any more, in either direction.
    // The class stays so the bar is already armed the moment reveal() paints it
    // and the bordered bar's own slide takes over. Amended 2026-08-13.
    //
    // Dropping the paint is safe on this side of the boundary in a way it is
    // not on the other: the ground under the bar here is always the
    // photograph, which is what the white coat is for. On the other side
    // dismissBeforeHero has already handled it, and the light coat's own rung
    // under the page is what keeps it from ghosting there.
    //
    // THE LIGHT BAR HAS NO OTHER STATE (Kyle, 2026-08-13, second pass). It is
    // rendered at full strength for the whole hero and never fades — page
    // content scrolling over it is the only thing that ever hides it, and that
    // is a stacking arrangement, not a class. An earlier pass faded it out on
    // a scroll line; that was backwards and the line is gone.
    pinOverHero() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden', 'eg-bar-painted');
    }

    // THE HOMEPAGE REVEAL FLOOR: the scroll offset the page must be strictly
    // PAST before the painted bar is allowed to reveal at all. Kyle, 2026-08-04
    // — two conditions, and the floor is the higher of the two:
    //
    //   a. NOT ONE PIXEL OF THE HERO ON SCREEN. `.eg-homehero-host` is
    //      `position: sticky; top: 0; z-index: 0` and stays pinned across the
    //      whole page, so it is never "scrolled past" — it is COVERED, by
    //      `.eg-homepanel-host` (z-index 1, opaque, full-bleed) riding up over
    //      it. Its last visible pixel therefore goes exactly when the panel's
    //      top edge reaches the top of the window, i.e. at the panel's own
    //      scroll offset. MEASURED at 1440x900 with an elementFromPoint grid,
    //      not assumed: the hero still hit-tests at scrollY 898 (panel rect top
    //      2px), and hit-tests NOWHERE from scrollY 900 (panel rect top 0) all
    //      the way to max scroll — re-checked after the culprits section landed
    //      (z-index 2), which keeps it covered past the panel's own end too.
    //   b. MORE THAN PANEL_LIP PAST THE TOP OF THE VANILLA PANEL.
    //
    // ANCHORED ON THE PANEL, AND THAT IS NOT INTERCHANGEABLE WITH THE HERO.
    // `.eg-homepanel-host` is the plain `position: relative` scroll track (the
    // sticky element is `.eg-homepanel` inside it), so its offsetTop is a
    // stable page-space number. The hero's is NOT: offsetTop on a stuck sticky
    // element reports its PINNED position, measured returning 4900 at scrollY
    // 4900. Reading the hero here would silently track the scroll instead of
    // the layout.
    //
    // MEMOISED, and invalidated on resize (see connectedCallback): the panel's
    // offset is the hero's height, and the hero is exactly 100vh.
    homeGeometry() {
      if (this.geometry === undefined) {
        const PANEL_LIP = 100;
        const panel = document.querySelector('.eg-homepanel-host');
        const hero = document.querySelector('.eg-homehero-host');

        if (panel) {
          // (a) and (b) share the same anchor, so (b) is the binding one.
          this.geometry = { heroAppearsAt: panel.offsetTop, revealFloor: panel.offsetTop + PANEL_LIP };
        } else if (hero) {
          // Hero but no panel: nothing covers it, so the honest boundary is
          // the hero's own extent. offsetHEIGHT, never offsetTop — see the
          // stuck-offsetTop trap above; the hero is the page's first section,
          // so its height IS its end. Cannot happen on today's homepage; here
          // so a template edit degrades to "suppressed" rather than "on".
          const heroEnd = hero.offsetHeight;
          this.geometry = { heroAppearsAt: heroEnd, revealFloor: heroEnd + PANEL_LIP };
        } else {
          // No hero at all — nothing to protect, so no floor. This is also the
          // answer for any non-homepage template, though `isOverlayHome` means
          // those never ask. Cannot throw.
          this.geometry = { heroAppearsAt: 0, revealFloor: 0 };
        }
      }
      return this.geometry;
    }

    homeRevealFloor() {
      return this.homeGeometry().revealFloor;
    }

    // Take a bar that was legitimately revealed ABOVE the floor back off the
    // screen before the hero returns.
    //
    // IT DISSOLVES, IT DOES NOT SLIDE (Kyle, 2026-08-13: at the top the dark
    // bar should fade out in place and reveal the white bar behind it, with no
    // vertical movement from either). So the whole method is now a single
    // un-paint: dropping `eg-bar-painted` hands the element to the light coat,
    // and component-eg-chrome.css crossfades ground, rule, ink and shadow on
    // the --eg-hh-nav-fade-* dials while holding the bar's z-index up for
    // exactly the length of the fade. NOTHING POSITIONAL IS TOUCHED — the bar
    // is already pinned at top 0 from reveal() and stays there.
    //
    // WHAT THIS REPLACES, so the deletion is not mistaken for a simplification:
    // it used to call hide(), read the bar's rect to follow the slide, and drop
    // the paint only once the box was off-screen — all of that existed to stop
    // the white coat being restored while the bar was still visible over the
    // Vanilla panel, which was the ghost-text bug. That danger is gone: the
    // light coat is a rung UNDER the page now, so the moment the fade ends the
    // panel closes over the bar. The rect read, the 2px cushion seam and the
    // fast-flick backstop all belonged to the slide and went with it.
    //
    // PANEL_LIP is still the runway. The dissolve gets the same 100px between
    // the reveal floor and the hero's first pixel that the slide had, and the
    // fade is the shorter of the two.
    dismissBeforeHero() {
      this.header.classList.remove('eg-bar-painted');
    }

    reset() {
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate',
        'eg-bar-painted'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // Kyle 2026-07-25: search is gated off (eg_search_enabled), so
      // <details-modal> may not render at all — guard instead of throwing
      // on every scroll-hide.
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
